export const transactionStatus = Object.freeze({
  PENDING: 'A receber',
  ACCOMPLISHED: 'Depositado',
})

export const transactionType: Record<
  string,
  Record<string, string>
> = Object.freeze({
  CREDIT: {
    ACCOMPLISHED: 'Depositado',
    PENDING: 'A receber',
  },
  REFUND: {
    ACCOMPLISHED: 'Estorno',
    PENDING: 'Estorno',
  },
  CHARGEBACK: {
    ACCOMPLISHED: 'Chargeback',
    PENDING: 'Chargeback',
  },
})

export const transactionPaymentMethod: Record<string, string> = Object.freeze({
  PIX: 'Pix',
  CREDIT_CARD: 'Crédito',
  NUPAY: 'Nupay' as const,
  NUPAY_CREDIT: 'Nupay Crédito' as const,
  NUPAY_DEBIT: 'Nupay Débito' as const,
})

export enum TransactionStatus {
  PENDING = 'PENDING',
  ACCOMPLISHED = 'ACCOMPLISHED',
}

export enum TransactionType {
  CREDIT = 'CREDIT',
  REFUND = 'REFUND',
  CHARGEBACK = 'CHARGEBACK',
}
